import * as React from 'react';
import { makeStyles } from '@mui/styles';
import { ICON_ARROW_UP, ICON_ARROW_DOWN } from '../_style';
import { Box, Collapse, Checkbox } from '@mui/material';


const useStyles = makeStyles((theme) => ({
  title: {
    padding: 20,
    fontSize: 18,
    fontWeight: 600,
  },
  iconArrow: {
    color: theme.palette.icon.main,
  },
  mainItem: {
    padding: '0 0 0 20px',
    minHeight: 50,
    display: 'flex',
    transition: '.3s',
    cursor: 'pointer',
    [theme.breakpoints.up('sm')]: {
      '&:hover': {
        background: theme.palette.background.hover,
      },
    },
    '&>div': {
      display: 'flex',
      alignItems: 'center',
    },
    '& .name': {
      flex: 1,
    },
  },
  subItem: {
    padding: '0 20px 0 40px',
    minHeight: 50,
    display: 'flex',
    transition: '.3s',
    cursor: 'pointer',
    [theme.breakpoints.up('sm')]: {
      '&:hover': {
        background: theme.palette.background.hover,
      },
    },
    '&>div': {
      display: 'flex',
      alignItems: 'center',
    },
    '& .name': {
      flex: 1,
    },
  },
}));


/** 第2層 */
const SubItem = ({index, subItem, subChange}) => {

  const classes = useStyles();

  const onChange = (e) => {
    subChange({
      index: index,
      value: e.target.checked
    });
  };


  return (
    <Box className={classes.subItem}>
      <Checkbox
        inputProps={{ 'aria-label': 'city Checkbox' }}
        checked={subItem.checked ? subItem.checked : false}
        onChange={onChange}
      />
      <Box className='name'>{subItem.name}</Box>
    </Box>
  )

}


/** 第1層 */
const MainItem = ({index, mainItem, MainCheckBox, callBack, secondaryKeys}) => {

  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [checked, setChecked] = React.useState(false);
  const [indeterminate, setIndeterminate] = React.useState(false);  // true-子選項有選，但非全選 / false-全選、全未選
  const [subItems, setSubItems] = React.useState(mainItem.list);
  const len = subItems.length;

  const openClick = () => {
    setOpen(!open);
  }

  // 第1層變動
  const onChange = (e) => {
    let value = e.target.checked;
    if(subItems.length > 0) {
      let newSubItems = [...subItems];
      if(value) {
        for(let i=0;i<len;i++) {
          newSubItems[i].checked = true;
        }
      } else {
        for(let i=0;i<len;i++) {
          delete newSubItems[i].checked;
        }
      }
      setSubItems(newSubItems);
      setCallBack(newSubItems);
    } else {
      setChecked(value);
      callBack({
        data: {
          index: index,
          value: value,
          list: subItems
        }
      })
    }
  };

  // 第2層變動
  const subChange = ({index, value}) => {
    let newSubItems = [...subItems];
    if(value) {
      newSubItems[index].checked = true;
    } else {
      delete newSubItems[index].checked;
    }
    setSubItems(newSubItems);
    setCallBack(newSubItems);
  }

  const setCallBack = (newSubItems) => {

    let checkValue = 0;
    newSubItems.forEach(item => {
      if(item.checked) checkValue++;
    });
    if(checkValue === len) {
      // 子項 全選
      setChecked(true);
      setIndeterminate(false);
      callBack({
        data: {
          index: index,
          value: true,
          list: newSubItems
        }
      })
    } else if(checkValue === 0) {
      // 子項 全未選
      setChecked(false);
      setIndeterminate(false);
      callBack({
        data: {
          index: index,
          value: false,
          list: newSubItems
        }
      })
    } else {
      // 子項 部份選
      setChecked(false);
      setIndeterminate(true);
      callBack({
        data: {
          index: index,
          value: false,
          list: newSubItems
        }
      })
    }
    
  };

  React.useEffect(() => {
    // 若第2層有選取，開起第1層
    if(subItems.length > 0) {
      let checked = subItems.find(item => item.checked === true);
      if(checked) {
        setOpen(true);
      } else {
        setOpen(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [secondaryKeys]);
  

  return (
    <>
      <Box className={classes.mainItem} onClick={openClick}>
        {
          MainCheckBox
          ?
            <Checkbox
              inputProps={{ 'aria-label': 'country Checkbox' }}
              onChange={onChange}
              onClick={(e) => e.stopPropagation()}
              checked={checked}
              indeterminate={indeterminate}
            />
          : null 
        }
        <Box className='name'>{mainItem.name}</Box>
        <Box>
        {
          subItems.length <= 0
          ? null
          :
            open
            ? <ICON_ARROW_UP classes={classes.iconArrow} />
            : <ICON_ARROW_DOWN classes={classes.iconArrow} />
        }
        </Box>
      </Box>
      <Collapse
        in={open}
        sx={{
          width: 'inherit',
        }}
      >
        {
          subItems.length <= 0
          ? null
          :
            subItems.map((subItem, subIndex) => (
              <Box key={`countryList_${subItem.code}`} >
                {
                  subItem.use === false
                  ? null
                  :
                    <SubItem
                      index={subIndex}
                      subItem={subItem}
                      subChange={subChange}
                    />
                }
              </Box>
            ))
        }
      </Collapse>
    </>
  )

}


/**
 * checkBox 列表（二層）
 * @param {string} title 標題
 * @param {array} data 資料
 * @param {boolean} checkBox 是否使用checkBox
 * @param {function} callBack 返回處理值
 * @param {array} secondaryKeys 第2層選取的值
 */
export function CheckBoxList({title, data, MainCheckBox, callBack, secondaryKeys}) {

  const classes = useStyles();


  return (
    <>
      <Box className={classes.title}>{title}</Box>
      {data.map((mainItem, index) => (
        <Box key={`countryList_${mainItem.code}`}>
          {
            mainItem.use === false
            ? null
            : <MainItem
                index={index}
                mainItem={mainItem}
                MainCheckBox={MainCheckBox}
                callBack={callBack}
                secondaryKeys={secondaryKeys}
              />
          }
        </Box>
      ))}
    </>
  )
}
